import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "indigo"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "text-2xl font-bold text-gray-900 mb-6" }
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6" }
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { value: "custom" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_11 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_12 = { class: "flex gap-1" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4 p-3 bg-blue-50 rounded-lg"
}
const _hoisted_14 = { class: "text-sm font-medium text-blue-800" }
const _hoisted_15 = { class: "text-sm text-blue-600 ml-4" }
const _hoisted_16 = {
  key: 0,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
}
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_18 = { class: "bg-gray-50" }
const _hoisted_19 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" }
const _hoisted_20 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" }
const _hoisted_21 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" }
const _hoisted_22 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_23 = { class: "px-6 py-3 text-sm text-gray-900" }
const _hoisted_24 = { class: "px-6 py-3 text-sm text-gray-900" }
const _hoisted_25 = { class: "px-6 py-3 text-sm text-gray-500" }
const _hoisted_26 = { class: "bg-gray-50" }
const _hoisted_27 = { class: "px-6 py-3" }
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = { class: "px-6 py-3 text-sm text-gray-900" }
const _hoisted_30 = { class: "px-6 py-3 text-sm text-gray-500" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "split_calculator"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.t('split.title')), 1 /* TEXT */),
      _createCommentVNode(" Input "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_6, _toDisplayString($setup.t('split.distance')), 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.selectedDistance) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.distances, (d) => {
                return _createElementVNode("option", {
                  key: d.value,
                  value: d.value
                }, _toDisplayString(d.label), 9 /* TEXT, PROPS */, _hoisted_7)
              }), 64 /* STABLE_FRAGMENT */)),
              _createElementVNode("option", _hoisted_8, _toDisplayString($setup.t('split.custom')), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.selectedDistance]
            ])
          ]),
          ($setup.selectedDistance === 'custom')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString($setup.t('split.custom_distance')) + " (m)", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.customDistance) = $event)),
                  type: "number",
                  min: "1",
                  placeholder: "1500",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                }, null, 512 /* NEED_PATCH */), [
                  [
                    _vModelText,
                    $setup.customDistance,
                    void 0,
                    { number: true }
                  ]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_11, _toDisplayString($setup.t('split.time')) + " (hh:mm:ss)", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.hours) = $event)),
                type: "number",
                min: "0",
                max: "99",
                placeholder: "00",
                class: "w-16 px-2 py-2 border border-gray-300 rounded-lg text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.hours]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "self-center text-gray-500 font-bold" }, ":", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.minutes) = $event)),
                type: "number",
                min: "0",
                max: "59",
                placeholder: "00",
                class: "w-16 px-2 py-2 border border-gray-300 rounded-lg text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.minutes]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "self-center text-gray-500 font-bold" }, ":", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.seconds) = $event)),
                type: "number",
                min: "0",
                max: "59",
                placeholder: "00",
                class: "w-16 px-2 py-2 border border-gray-300 rounded-lg text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.seconds]
              ])
            ])
          ])
        ]),
        ($setup.pace)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.t('split.pace')) + ": " + _toDisplayString($setup.pace) + " " + _toDisplayString($setup.t('split.min_km')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_15, _toDisplayString($setup.speedKmh) + " " + _toDisplayString($setup.t('split.km_h')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Results table "),
      ($setup.totalSeconds > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", _hoisted_18, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_19, _toDisplayString($setup.t('split.distance')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_20, _toDisplayString($setup.t('split.time')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_21, _toDisplayString($setup.t('split.pace')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.splits, (split) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: split.distance,
                    class: _normalizeClass(split.distance === $setup.inputDistanceMeters ? 'bg-blue-50 font-semibold' : 'hover:bg-gray-50')
                  }, [
                    _createElementVNode("td", _hoisted_23, _toDisplayString(split.label), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(split.time), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(split.pace), 1 /* TEXT */)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */)),
                _createCommentVNode(" Custom row "),
                _createElementVNode("tr", _hoisted_26, [
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.tableCustomDistance) = $event)),
                        type: "number",
                        min: "1",
                        placeholder: "1500",
                        class: "w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      }, null, 512 /* NEED_PATCH */), [
                        [
                          _vModelText,
                          $setup.tableCustomDistance,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "m", -1 /* CACHED */))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_29, _toDisplayString($setup.tableCustomTime), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_30, _toDisplayString($setup.tableCustomPace), 1 /* TEXT */)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}